import { BRAND } from "../../lib/brand";

export default function ServiceArea() {
  return (
    <section
      data-testid="service-area"
      className="py-20 md:py-28 bg-ink-mist border-t border-ink-line"
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
            Service Area
          </div>
          <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
            Local team.{" "}
            <span className="font-serif-italic font-normal text-ink-mid">
              National reach.
            </span>
          </h2>
        </div>

        {/* Split coverage — Epoxy pan-India vs Waterproofing/Painting NCR */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div
            data-testid="coverage-epoxy"
            className="bg-ink text-white p-6 md:p-8"
          >
            <div className="flex items-center justify-between gap-3">
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/60">
                Epoxy Flooring
              </div>
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase bg-orange text-white px-2.5 py-1">
                Pan India
              </span>
            </div>
            <h3 className="mt-4 font-display text-xl md:text-2xl leading-tight">
              Available across India for industrial, warehouse, factory,
              showroom and commercial projects.
            </h3>
            <p className="mt-3 text-white/70 text-sm leading-relaxed">
              Share the city, area (sqft) and timeline — our team will
              respond with a plan and quote.
            </p>
          </div>

          <div
            data-testid="coverage-wp-paint"
            className="bg-white border border-ink-line p-6 md:p-8"
          >
            <div className="flex items-center justify-between gap-3">
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-ink-muted">
                Waterproofing &amp; Painting
              </div>
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase border border-ink px-2.5 py-1 text-ink">
                Gurugram &amp; NCR
              </span>
            </div>
            <h3 className="mt-4 font-display text-xl md:text-2xl leading-tight text-ink">
              Focused delivery across Gurugram, Manesar, Sohna and Delhi NCR.
            </h3>
            <p className="mt-3 text-ink-muted text-sm leading-relaxed">
              A local team allows us to keep the sequencing tight — inspection,
              preparation, application and finishing on a controlled timeline.
            </p>
          </div>
        </div>

        <ul className="mt-10 flex flex-wrap gap-2 justify-center">
          {BRAND.service_area.map((area) => (
            <li
              key={area}
              data-testid={`area-${area.toLowerCase().replace(/\s+/g, "-")}`}
              className="border border-ink-line bg-white px-4 py-2 text-xs md:text-sm text-ink hover:border-ink transition-colors"
            >
              {area}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
